import React from 'react';
import PropTypes from 'prop-types';

import * as S from './style';
import Input from '../form-components/input';

const ContestDetails = ({ fields }) => {
  return (
    <S.ContestDetails>
      <S.SerialInputs>
        <Input field={fields.FirstName} />
        <Input field={fields.LastName} />
      </S.SerialInputs>

      <Input field={fields.EmailAddress} />

      <Input field={fields.CountryOfResidence} />

      <S.SerialInputs>
        <Input field={fields.PhotoSkills} />
        <Input field={fields.VideoSkills} />
      </S.SerialInputs>

      <Input field={fields.PhotoCaption} />

      <Input field={fields.Media} />

      <Input field={fields.MainGenre} />

      <Input field={fields.ProductStatement} />

      <S.SerialInputs>
        <Input field={fields.ProfileStatement} />
        <Input field={fields.PrintStatement} />
      </S.SerialInputs>

      <Input field={fields.AgeStatement} />

      <Input field={fields.ProfessionStatement} />

      <Input field={fields.MarketingConsent} />

      <Input field={fields.DataPrivacyPolicy} />

      <Input field={fields.TermsAndConditions} />

      <Input field={fields.PhotogalleryConsent} />

      {fields.TransferConsent ? <Input field={fields.TransferConsent} /> : null}

      <Input field={fields.CAPTCHA} />
    </S.ContestDetails>
  );
};

export default ContestDetails;

ContestDetails.propTypes = {
  fields: PropTypes.object,
};
